import type { ReactNode } from "react";

import { classNames, Spinner } from "@alpacahq/ui/old";

import { FAQ, type FAQItem } from "~/v2/components/common/FAQ";
import { ProgressBar } from "./ProgressBar";

export interface OnboardingLayoutProps {
  title: string;
  percentage: number;
  isLoading?: boolean;
  className?: string;
  faq?: FAQItem[];
  children: ReactNode;
}

export const OnboardingLayout = ({
  title,
  percentage,
  isLoading = false,
  className,
  faq,
  children,
}: OnboardingLayoutProps) => {
  const hasFaq = faq && faq.length > 0;

  return (
    <div
      className={classNames(
        "fade-in-up-medium mx-auto mt-5 mb-16 w-full max-w-[1200px] px-2 xl:px-0",
        className,
      )}
    >
      <h1 className="mb-5 font-medium text-xl">{title}</h1>
      <ProgressBar className="mb-2.5" percentage={percentage} />

      {isLoading ? (
        <div className="mt-16 mb-96 flex items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <div className="mt-6 flex flex-col items-start justify-start gap-8 lg:grid lg:grid-cols-[1fr_minmax(200px,362px)]">
          <div className="w-full">{children}</div>
          <div>{hasFaq && <FAQ faq={faq} />}</div>
        </div>
      )}
    </div>
  );
};
